<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Buscar en la tabla..."
  />
</mat-form-field>

<div class="mat-elevation-z8" align="center">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    multiTemplateDataRows
    class="mat-elevation-z8"
  >
    <ng-container
      matColumnDef="{{ column }}"
      *ngFor="let column of columnsToDisplay"
    >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column }}</th>
      <td mat-cell *matCellDef="let element">
        <p
          *ngIf="
            column !== 'type' &&
            column !== 'param' &&
            column !== 'acciones' &&
            column !== 'activeElement'
          "
          [ngClass]="column === 'acciones' ? element.acciones : ''"
          class="noMarginBottom"
        >
          {{ element[column] }}
        </p>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
  <mat-paginator
    #TableGatewayRaizPaginator="matPaginator"
    [pageSizeOptions]="[10, 20, 100]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
